const StreamsIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24" height="24" viewBox="0 0 24 24"
		fill="currentColor"
		stroke="none"
		{...props}
	>
		<path d="M16 10V12H8V10H10V9H4V11H2V3H4V5H12C12.5304 5 13.0391 5.21071 13.4142 5.58579C13.7893 5.96086 14 6.46957 14 7V10H16ZM10 15V18C10 18.5304 10.2107 19.0391 10.5858 19.4142C10.9609 19.7893 11.4696 20 12 20H20V22H22V14H20V16H14V15H16V13H8V15H10Z" />
	</svg>
)

export default StreamsIcon